import MT from "../../assets/images/live-bg/MT.jpg";
import MC from "../../assets/images/live-bg/MC.jpg";
import TC from "../../assets/images/live-bg/TC.jpg";
import KH from "../../assets/images/live-bg/KH.jpg";
import SC from "../../assets/images/live-bg/SC.jpg";
import LEAP from "../../assets/images/live-bg/MHSB.jpg";
import KP_MT_DAY from "../../assets/images/live-bg/KP-MT-Day.jpg";
import KP_MT_NIGHT from "../../assets/images/live-bg/KP-MT-Night.jpg";
import KP_MC_DAY from "../../assets/images/live-bg/KP-MC-Day.jpg";
import KP_MC_NIGHT from "../../assets/images/live-bg/KP-MC-Night.jpg";

const images = { MT, MC, TC, KH, SC, LEAP };
const aliases = { VNONE: "MC", TN: "TC", TC_MINHNGOC: "TC", LEAP5D: "LEAP", LEAP6D: "LEAP", MHSB: "LEAP" };
const normalize = (type) => {
    const key = String(type || "").toUpperCase().replace(/-BLACK$/, "");
    return aliases[key] || key;
};

export function getLiveBackground(routeType, result = {}) {
    const apiType = normalize(result.lotteryType || result.type);
    const type = images[apiType] || apiType === "KP" ? apiType : normalize(routeType);
    if (type === "KP") {
        // Match the KP family selection used by the result pages.
        const isMC = ["kp16", "kp18"].includes(result.shiftCode);
        return isMC
            ? (result.isNight ? KP_MC_NIGHT : KP_MC_DAY)
            : (result.isNight ? KP_MT_NIGHT : KP_MT_DAY);
    }
    return images[type];
}
